import React, { Fragment } from 'react';
import { cx } from 'emotion';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styles from './styles';
import { observable } from 'mobx';
import { Dropdown, Icon, Input, Select } from 'semantic-ui-react';
import type { DataStore } from 'types/common';
import * as yup from 'yup';
import DayPickerInput from 'components/DayPickerInput';

@observer
export default class SortByField extends React.Component {
	props: {
		label: PropTypes.string,
		field: PropTypes.string,
		store: DataStore,
		enableFiltering: PropTypes.bool,
		filterType: 'like' | 'text' | 'date' | 'select',
		options?: Array<{ key: string, value: string, text: string }>
	};

	@observable filterValue: string = '';
	@observable dateCompValue: string = '=';
	@observable filterOpen: boolean = false;

	constructor(props) {
		super(props);
	}

	static defaultProps = {
		enableFiltering: false,
		filterType: 'like'
	};

	triggerFiltering = () => {
		const { store, filterType, field } = this.props;
		if (filterType === 'text' || filterType === 'like') {
			let isNotEmpty = yup
				.string()
				.ensure()
				.min(1)
				.isValidSync(this.filterValue);
			if (!isNotEmpty) {
				store.removeFilter(field);
				return;
			}
			if (filterType === 'like') {
				store.addFilter({ field, value: { like: `%25${this.filterValue}%25` } });
			} else {
				store.addFilter({ field, value: this.filterValue });
			}
		} else if (filterType === 'date') {
			if (!this.filterValue) {
				store.removeFilter(field);
				return;
			}
			if (this.dateCompValue === '=') {
				const valueDay = new Date(this.filterValue);
				const nextDay = new Date(valueDay.setDate(valueDay.getDate() + 1))
					.toISOString()
					.slice(0, 10);
				store.addFilters([
					{ field, value: { gte: this.filterValue } },
					{ field, value: { lte: nextDay } }
				]);
			} else if (this.dateCompValue === '<') {
				store.addFilter({ field, value: { lt: this.filterValue } });
			} else if (this.dateCompValue === '>') {
				store.addFilter({ field, value: { gt: this.filterValue } });
			}
		} else if (filterType === 'select') {
			if (!this.filterValue) {
				store.removeFilter(field);
				return;
			}
			store.addFilter({ field, value: this.filterValue });
		}
	};

	render() {
		const { label, label2, field, enableFiltering, store, filterType, options } = this.props;
		let icon = null;
		let isAsc = false;

		if (store.orderBy.field === field) {
			isAsc = store.orderBy.asc;
			icon = <i className={cx('icon chevron', isAsc ? 'up' : 'down')} />;
		}

		return (
			<div className={styles.wrapper}>
				<a
					href="javascript:void(0)"
					onClick={() => store.setOrderBy(field)}
					className={styles.header}
				>
					{label}{' '}
					{label2 && (
						<Fragment>
							<br />
							{label2}
						</Fragment>
					)}
					{icon}
				</a>
				{enableFiltering && (
					<a
						href="javascript:void(0)"
						className={styles.filterIcon}
						onClick={() => {
							this.filterOpen = !this.filterOpen;
						}}
						title="Open/Close"
					>
						<i className="icon filter" />
					</a>
				)}
				{this.filterOpen && (
					<div className={styles.filterWrapper}>
						{(filterType === 'like' || filterType === 'text') && (
							<div className={styles.textWrapper}>
								<Input
									size="small"
									value={this.filterValue}
									onChange={e => {
										this.filterValue = e.target.value;
									}}
									onKeyPress={e => {
										if (e.key === 'Enter') {
											this.triggerFiltering();
										}
									}}
								/>
								<Icon
									link
									name="check"
									size="large"
									onClick={() => {
										this.triggerFiltering();
									}}
								/>
							</div>
						)}
						{filterType === 'date' && (
							<div className={styles.dateWrapper}>
								<Select
									options={['=', '<', '>'].map(el => {
										return { value: el, text: el, key: el };
									})}
									value={this.dateCompValue}
									onChange={(e, data) => {
										this.dateCompValue = data.value;
									}}
								/>
								<DayPickerInput
									asFormField={false}
									value={this.filterValue?.toDate() || ''}
									onDayChange={day => {
										if (day) {
											const tzoffset = day.getTimezoneOffset() * 60000;
											const localISOTime = new Date(day.getTime() - tzoffset)
												.toISOString()
												.slice(0, -1);
											this.filterValue = day && localISOTime.slice(0, 10);
										}
									}}
								/>
								<Icon
									link
									name="close"
									size="large"
									onClick={() => {
										this.filterValue = null;
										this.triggerFiltering();
									}}
								/>
								<Icon
									link
									name="check"
									size="large"
									onClick={() => {
										this.triggerFiltering();
									}}
								/>
							</div>
						)}
						{filterType === 'select' && (
							<div className={styles.selectWrapper}>
								<Dropdown
									selection
									fluid
									options={options}
									placeholder="Start typing"
									search
									onChange={(e, data) => {
										this.filterValue = data.value;
										this.triggerFiltering();
									}}
									value={this.filterValue}
								/>
								<Icon
									link
									name="close"
									size="large"
									onClick={() => {
										this.filterValue = null;
										this.triggerFiltering();
									}}
								/>
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/SortByField/index.js